// extracted by mini-css-extract-plugin
module.exports = {"main":"Projects_main__27uc6"};